export default "__VITE_ASSET__5ab69d89__"